import React, { useMemo } from 'react';
import { cloneDeep, isEmpty } from 'lodash';
import { computeHighlights, ProHighlight } from '@fiverr-private/experts';
import { getContext } from '@fiverr-private/fiverr_context';
import { SafeWrapper } from '@fiverr-private/seller_pages_toolbox';

const HIGHLIGHTS_TO_SHOW = 4;

/** @type {import('./index').Highlights} */
const Highlights = ({ highlightsData = {}, sellerData = {}, className }) => {
    const { locale, browserLanguage, countryCode } = getContext();

    const highlights = useMemo(
        () =>
            highlightsData &&
            computeHighlights({
                sellerData,
                collaborateData: highlightsData.collaborateData,
                saveData: highlightsData.saveData,
                matchingIndustriesData: highlightsData.matchingIndustriesData,
                locale,
                browserLanguage,
                countryCode,
                hideProVerifiedHighlight: true,
                highlightsToShow: HIGHLIGHTS_TO_SHOW,
            }),
        [highlightsData, countryCode, sellerData, browserLanguage, locale]
    );

    if (isEmpty(highlights)) {
        return null;
    }

    // Needs deep equal, because Highlight has mutating code inside, which causes additional rerendering and page breaks
    return (
        <div className={className}>
            {highlights.map((highlight) => (
                <ProHighlight
                    className="m-r-12"
                    key={highlight.type}
                    type={highlight.type}
                    additionalData={cloneDeep(highlight.additionalData)}
                />
            ))}
        </div>
    );
};

/** @type {typeof Highlights} */
export default SafeWrapper(Highlights, 'Highlights');
